/**
 * Static lists + column sets for the Vacancy Update page, migrated from the
 * hardcoded arrays in Angular `VacancyUpdateComponent`.
 */

export interface Option {
  value: string;
  label: string;
}

export interface ColumnDef {
  field: string;
  header: string;
}

// ── Column sets per mode (Angular selectedColumns) ──────────────────────────

export const AIDED_COLUMNS: ColumnDef[] = [
  { field: 'District', header: 'District' },
  { field: 'EduDis', header: 'Education District' },
  { field: 'Block', header: 'Block' },
  { field: 'udise_code', header: 'UDISE' },
  { field: 'school', header: 'School Name' },
  { field: 'Category', header: 'Category' },
  { field: 'Vacancy', header: 'Vacancy' },
];

export const SCERT_COLUMNS: ColumnDef[] = [
  { field: 'District', header: 'District' },
  { field: 'EduDis', header: 'Education District' },
  { field: 'Block', header: 'Block' },
  { field: 'school', header: 'Office Name' },
  { field: 'Vacancy', header: 'Vacancy' },
  { field: 'Need', header: 'Need' },
];

export const NORMAL_COLUMNS: ColumnDef[] = [
  { field: 'District', header: 'District' },
  { field: 'EduDis', header: 'Education District' },
  { field: 'Block', header: 'Block' },
  { field: 'udise_code', header: 'UDISE' },
  { field: 'school', header: 'School Name' },
  { field: 'Category', header: 'Category' },
  { field: 'Vacancy', header: 'Vacancy' },
  { field: 'Need', header: 'Need' },
];
